import * as React from "react";
import { Button, Divider, Grid, Tab, Segment } from "semantic-ui-react";

import { Detail } from "@neworbit/simpleui-detail";

import * as moment from "moment";

import DeleteButton from "../DeleteButton";
import { RoomDetailModel } from "../../model";

import { Link } from "redux-little-router";

export const CoreDetails: React.FC<{ room: RoomDetailModel }> = (props) => {
    return (
        <Grid>
            <Detail label="Name" value={props.room.name} labelWidth={5} valueWidth={11} />
            <Detail label="Address Line1" value={props.room.addressLine1 ?? ""} labelWidth={5} valueWidth={11} />
            <Detail label="Address Line2" value={props.room.addressLine2 ?? ""} labelWidth={5} valueWidth={11} />
            <Detail label="Address Line3" value={props.room.addressLine3 ?? ""} labelWidth={5} valueWidth={11} />
            <Detail label="City" value={props.room.city ?? ""} labelWidth={5} valueWidth={11} />
            <Detail label="County" value={props.room.county ?? ""} labelWidth={5} valueWidth={11} />
            <Detail label="Postcode" value={props.room.postcode ?? ""} labelWidth={5} valueWidth={11} />
            <Detail label="Internal Notes" value={props.room.notes ?? ""} labelWidth={5} valueWidth={11} />
            <Detail label="Customer Notes" value={props.room.customerNotes ?? ""} labelWidth={5} valueWidth={11} />
            <Detail label="Working Day Start Time" value={props.room.workingDayStartTime ?? ""} labelWidth={5} valueWidth={11} />
            <Detail label="Working Day Finish Time" value={props.room.workingDayEndTime ?? ""} labelWidth={5} valueWidth={11} />
            {props.room.position && <Detail
                label="Coordinates"
                value={`Latitude: ${props.room.position[1]}, Longitude: ${props.room.position[0]}`}
                labelWidth={5}
                valueWidth={11}
            />}
            <Detail
                label="Geocode status"
                value={props.room.geocodeStatus ?? (props.room.position ? "Geocoded" : "Not Geocoded")}
                labelWidth={5}
                valueWidth={11}
            />
            <Detail
                label="Working Week"
                value={(props.room.workingDays || []).sort().map(day => moment.weekdays(true, day)).join(", ")}
                labelWidth={5}
                valueWidth={11}
            />
        </Grid>
    );
};

const CoreDetailsWithActions: React.FunctionComponent<{ room: RoomDetailModel; path: string }> = (props) => {
    return (
        <div>
            <CoreDetails room={props.room} />

            <Divider />
            <Segment basic clearing vertical>
                <DeleteButton />
                <Button icon="pencil" content="Edit" floated="right" as={Link} href={`${props.path}/edit`} />
            </Segment>
        </div>
    );
};

export const coreDetailsTab = (props: { room: RoomDetailModel; path: string }) => ({
    path: "",
    menuItem: "Details",
    render: () => <Tab.Pane><CoreDetailsWithActions {...props} /></Tab.Pane>
});
